import { render } from "./InstallerLayout.vue?vue&type=template&id=f9eee9d0&scoped=true"
import script from "./InstallerLayout.vue?vue&type=script&lang=js"
export * from "./InstallerLayout.vue?vue&type=script&lang=js"

import "./installer-layout.scss?vue&type=style&index=0&id=f9eee9d0&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.8\\installer\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9eee9d0"]])

export default __exports__